import { motion } from "framer-motion";

export const SectionHeading = ({ eyebrow, title, description, align = "left", testIdPrefix = "section" }) => {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  const maxW = align === "center" ? "max-w-3xl" : "max-w-3xl";
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.4 }}
      className={`${alignCls} ${maxW}`}
      data-testid={`${testIdPrefix}-heading`}
    >
      {eyebrow && (
        <div className="text-xs font-semibold uppercase tracking-[0.16em] text-blue-700">
          {eyebrow}
        </div>
      )}
      <h2 className="mt-3 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-[44px] lg:leading-[1.08]">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-base leading-relaxed text-slate-600 md:text-lg">{description}</p>
      )}
    </motion.div>
  );
};
